import React, { useState } from "react";
import { Box, TextField } from "@mui/material";
import DOMPurify from "dompurify";

function NCXFormInputField(props) {
  const mandatory = props?.field?.properties?.mandatory || false;
  const [localValue, setLocalValue] = useState();
  const fieldname = props?.field?.properties?.fieldname;
  const sharedStyles = {
    marginBottom: props?.field?.properties?.margin || "16px",
    width: "100%",
    display: "flex",
  };

  const onInputChange = (e) => {
    const rawValue = e.target.value;

    // Sanitize the input value to prevent XSS attacks
    const sanitizedValue = DOMPurify.sanitize(rawValue, {
      ALLOWED_TAGS: [], // No HTML tags allowed
      ALLOWED_ATTR: [], // No HTML attributes allowed
      KEEP_CONTENT: true, // Keep text content, strip HTML
    });

    setLocalValue(sanitizedValue);
    props?.handleInputChange(fieldname, sanitizedValue, props?.field);
  };

  return (
    <Box key={props?.field._id} sx={{ marginBottom: "16px" }}>
      <TextField
        required={mandatory}
        label={props?.field?.properties?.label}
        name={fieldname}
        placeholder={`Enter ${props?.field?.properties?.label}`}
        value={localValue || ""}
        onChange={onInputChange}
        variant="outlined"
        size="medium"
        sx={sharedStyles}
        error={!!props?.validationErrors[fieldname]}
        helperText={props?.validationErrors[fieldname]}
        multiline={props?.multiline}
        rows={props?.multiline ? 3 : 1}
        type={props?.field?.properties?.sensitiveData ? "password" : "text"}
        disabled={props?.field?.properties?.readOnly}
      />
    </Box>
  );
}

export default NCXFormInputField;
